import { Routes } from '@angular/router';
import { ProductsComponent } from '../components/products/products.component';
import { ShoppingCartComponent } from '../components/products/shoppingcart/shopping.cart.component';
import {
    ProductDetailComponent,
    productDetailRoute,
} from '../components/products/productdetail.component';
import { LoginComponent } from '../generic/component/login/login.component';
import { ForgotPasswordComponent } from '../generic/component/login/forgot.password.component';
import { ResetPasswordComponent } from '../generic/component/login/reset.password.component';
import { PendingOrdersComponent } from '../generic/component/my/order/pending/pending.orders.component';
import { OrderHistoryComponent } from '../components/my/order/history/history.component';
import { OrderHistoryDetailComponent } from '../components/my/order/history/history.detail.component';
import { PricelistsComponent } from '../generic/component/my/pricelists/pricelists.component';
import { PendingOrderDetailComponent } from '../components/my/order/pending/pending.order.detail.component';
import { NotfoundComponent } from '../generic/component/notfound/notfound.component';
import { alreadyLoggedInGuard } from '../security/already-logged-in.guard.service';
import { loggedInMandatoryGuard } from '../security/logged-in-mandatory-guard.service';
import { BlogListComponent } from '../components/blog/blog.list.component';
import { HuntersOverviewComponent } from '../components/hunters/hunters.overview.component';
import { HuntersDetailComponent } from '../components/hunters/hunters.detail.component';
import {
    huntersDetailUrl,
    huntersOverviewUrl,
} from '../generic/service/planthunter.service';
import { BlogDetailComponent } from '../components/blog/blog.detail.component';
import { productHistoryGuard } from '../security/product-history.guard.service';
import { myFavoritesGuard } from '../security/my-favorites.guard.service';
import { ClaimOverviewComponent } from '../components/my/claims/claim.overview.component';
import { ClaimDetailComponent } from '../components/my/claims/claim.detail.component';
import { NewClaimOverviewComponent } from '../components/my/claims/new.claim.overview.component';
import { loggedInGuard } from '../security/logged-in.guard.service';

export const appRoutes: Routes = [
    {
        path: 'products',
        data: { isPlantscaping: 0 },
        component: ProductsComponent,
        canActivate: [loggedInMandatoryGuard],
    },
    {
        path: 'products/history',
        children: [],
        canActivate: [productHistoryGuard],
    },
    {
        path: 'products/plantscaping',
        data: { isPlantscaping: 1 },
        component: ProductsComponent,
        canActivate: [loggedInMandatoryGuard],
    },

    { path: '', redirectTo: '/products', pathMatch: 'full' },

    {
        path: 'blogs',
        component: BlogListComponent,
        canActivate: [loggedInGuard],
    },
    {
        path: 'blogs/detail',
        component: BlogDetailComponent,
        canActivate: [loggedInGuard],
    },
    {
        path: huntersOverviewUrl,
        component: HuntersOverviewComponent,
        canActivate: [loggedInGuard],
    },
    {
        path: huntersDetailUrl,
        component: HuntersDetailComponent,
        canActivate: [loggedInGuard],
    },

    {
        path: 'login',
        component: LoginComponent,
        canActivate: [alreadyLoggedInGuard],
    },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'reset-password', component: ResetPasswordComponent },

    {
        path: productDetailRoute,
        component: ProductDetailComponent,
        canActivate: [loggedInGuard],
    },
    {
        path: 'products/shoppingcart',
        component: ShoppingCartComponent,
        canActivate: [loggedInGuard],
    },

    {
        path: 'my/pending/orders',
        component: PendingOrdersComponent,
        canActivate: [loggedInGuard],
    },
    {
        path: 'my/pending/orders/detail',
        component: PendingOrderDetailComponent,
        canActivate: [loggedInGuard],
    },

    {
        path: 'my/pricelists',
        component: PricelistsComponent,
        canActivate: [loggedInGuard],
    },

    {
        path: 'my/order/history',
        component: OrderHistoryComponent,
        canActivate: [loggedInGuard],
    },
    {
        path: 'my/order/history/detail',
        component: OrderHistoryDetailComponent,
        canActivate: [loggedInGuard],
    },

    { path: 'my/favorites', children: [], canActivate: [myFavoritesGuard] },
    {
        path: 'my/claims',
        component: ClaimOverviewComponent,
        canActivate: [loggedInGuard],
    },
    {
        path: 'my/claims/detail',
        component: ClaimDetailComponent,
        canActivate: [loggedInGuard],
    },
    {
        path: 'my/claims/new',
        component: NewClaimOverviewComponent,
        canActivate: [loggedInGuard],
    },
    // Catch all route, will be used when nothing else matches to display a 404
    {
        path: '**',
        component: NotfoundComponent,
        canActivate: [loggedInMandatoryGuard],
    },
];
